export default "https://cdn-static.gokick.com/assets/9903bb00b89f5bdf744fe0cfa18ff86718068cd8/images/tangerine-flavor.1fe86552bc4a40407da21340599dcac8.png";